import { ColumnEditorOptions } from "primereact/column";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";

export const CustomEstimateCostEditor = (options: ColumnEditorOptions) => {
    if (options.rowData.estimateDefectCostRangeId !== 1) {
        return undefined;
    }

    const onChange = (event: InputNumberValueChangeEvent) => {
        if (options.editorCallback) {
            options.editorCallback(event.value);
        }
    };
    
    return <InputNumber autoFocus value={options.value} minFractionDigits={2} onValueChange={onChange}/>;
}